import { _ as __rest } from '../tslib.es6-c563c1dd.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { TextField } from '@mui/material';
import NumberFormat from 'react-number-format';

const NumberFormatCustom = forwardRef(function NumberFormatCustom(_a, ref) {
    var { onChange, name, integer, decimal } = _a, rest = __rest(_a, ["onChange", "name", "integer", "decimal"]);
    return (jsx(NumberFormat, Object.assign({}, rest, { getInputRef: ref, onValueChange: values => {
            onChange({
                target: {
                    name,
                    value: values.value,
                },
            });
        }, thousandSeparator: ".", decimalSeparator: ",", decimalScale: decimal, allowEmptyFormatting: true, fixedDecimalScale: true, isNumericString: true, isAllowed: values => values.value.toString().length - decimal - 1 <= integer })));
});
const QuantityInput = (_a) => {
    var { label, value, handleChange, name, disabled, integer = 10, decimal = 2, InputProps } = _a, rest = __rest(_a, ["label", "value", "handleChange", "name", "disabled", "integer", "decimal", "InputProps"]);
    return (jsx(TextField, Object.assign({ value: value, name: name, label: label, disabled: disabled, fullWidth: true, onChange: event => {
            handleChange(event, event.target.value);
        }, InputProps: Object.assign(Object.assign({}, InputProps), { inputProps: Object.assign(Object.assign({}, InputProps === null || InputProps === void 0 ? void 0 : InputProps.inputProps), { integer,
                decimal }), inputComponent: NumberFormatCustom }) }, rest)));
};

export { QuantityInput };
